'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _DatePicker = require('./DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DatePicker2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/DatePicker/index.js
 ** module id = 659
 ** module chunks = 0
 **/